/**
 * Clickable asset cards for source/target selection
 */
import type React from "react";
import type { SmartAssetData } from "../../types";

export interface WireAssetCardsProps {
  selectedAssets: SmartAssetData[];
  sourceAsset: string;
  targetAsset: string;
  onAssetClick: (assetId: string) => void;
  getCardBorderClass: (assetId: string) => string;
}

export const WireAssetCards: React.FC<WireAssetCardsProps> = ({
  selectedAssets,
  sourceAsset,
  targetAsset,
  onAssetClick,
  getCardBorderClass,
}) => (
  <div className="flex flex-wrap gap-4 mb-6">
    {selectedAssets.map((asset) => (
      <button
        key={asset.id}
        type="button"
        onClick={() => onAssetClick(asset.id)}
        className={`flex-1 min-w-[200px] p-4 bg-sa-surface-hover rounded-lg text-left transition-all cursor-pointer ${getCardBorderClass(asset.id)}`}
      >
        <div className="flex items-center gap-2 mb-3">
          {asset.iconPath && (
            <img src={asset.iconPath} alt={asset.name} className="w-8 h-8 rounded" />
          )}
          <span className="font-medium text-sa-text">{asset.name}</span>
          {sourceAsset === asset.id && (
            <span className="ml-auto px-2 py-0.5 text-xs font-medium bg-primary/10 text-primary rounded">
              Source
            </span>
          )}
          {targetAsset === asset.id && (
            <span className="ml-auto px-2 py-0.5 text-xs font-medium bg-sa-success/10 text-sa-success rounded">
              Target
            </span>
          )}
        </div>
        <div className="space-y-1 text-xs">
          <div className="text-primary">
            <span className="font-medium">Outputs:</span> signal_out, value_out, charge_out
          </div>
          <div className="text-sa-success">
            <span className="font-medium">Inputs:</span> signal_in, value_in, charge_in
          </div>
        </div>
      </button>
    ))}
  </div>
);
